import React from 'react';

import Inline from '@atlaskit/primitives/inline';
import { xcss } from '@atlaskit/primitives/xcss';

const styles = xcss({
	gridArea: 'title',
	font: 'font.heading.large',
});

export const Title = ({ children }: React.PropsWithChildren<unknown>): React.JSX.Element => {
	return (
		<Inline xcss={styles} alignBlock="center" space="space.100">
			{children}
		</Inline>
	);
};
